import React, { createContext, useContext } from "react";
import { usePaletteColor } from "../hooks/use-palette-color";
export const IconComponentContext = createContext(null);
export const useIconComponent = () => useContext(IconComponentContext);
export const IconComponentProvider = ({ IconComponent, children }) => {
    return <IconComponentContext.Provider value={IconComponent ?? null}>{children}</IconComponentContext.Provider>;
};
export const Icon = ({ color = "on-background", ...rest }) => {
    const IconComponent = useIconComponent();
    if (!IconComponent) {
        throw new Error("`IconComponent` is undefined. Seems like you forgot to wrap your component with `Provider`.");
    }
    const { main } = usePaletteColor(color);
    return <IconComponent {...rest} color={main}/>;
};
